// Flip RIDES_ENABLED to true when auto/taxi service launches
export const FEATURES = {
  RIDES_ENABLED: false,
};
